import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        this.play()
    }

    play() {
        if (this.element.paused) {
            this.element.play().catch((error) => {
                console.error('Video play failed:', error)
            })
        }
    }
}
